import React, { useEffect, useId, useRef, useState } from "react";

const GuestSelect = ({
    name,
    value,
    onChange,
    options,
    placeholder,
    required = false,
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const rootRef = useRef(null);
    const listId = useId();

    const selectedLabel =
        options.find((option) => option.value === value)?.label || "";

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (rootRef.current && !rootRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const handleSelect = (optionValue) => {
        onChange({ target: { name, value: optionValue } });
        setIsOpen(false);
    };

    return (
        <div
            className={`guest-select ${isOpen ? "guest-select--open" : ""}`}
            ref={rootRef}
        >
            <input type="hidden" name={name} value={value} required={required} />

            <button
                type="button"
                className="guest-select__trigger"
                aria-haspopup="listbox"
                aria-expanded={isOpen}
                aria-controls={listId}
                onClick={() => setIsOpen((prev) => !prev)}
            >
                <span
                    className={
                        selectedLabel
                            ? "guest-select__value"
                            : "guest-select__placeholder"
                    }
                >
                    {selectedLabel || placeholder}
                </span>
                <span className="guest-select__chevron" aria-hidden="true" />
            </button>

            {isOpen && (
                <ul
                    id={listId}
                    className="guest-select__dropdown"
                    role="listbox"
                >
                    {options.map((option) => (
                        <li
                            key={option.value}
                            role="option"
                            aria-selected={option.value === value}
                        >
                            <button
                                type="button"
                                className={`guest-select__option ${
                                    option.value === value
                                        ? "guest-select__option--selected"
                                        : ""
                                }`}
                                onClick={() => handleSelect(option.value)}
                            >
                                {option.label}
                            </button>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default GuestSelect;

